{
  "id": "litessera-lux",
  "name": "Litessera Lux",
  "kind": "simulator",
  "spotlight": true,
  "url": "",
  "homepage": "https://lyszt.net/en/toolkit/litessera-lux",
  "origin": "João Luis Almeida Santos, lyszt",
  "authors": [
    "João Luis Almeida Santos"
  ],
  "started": 2026,
  "language": "JavaScript, C++, WebAssembly",
  "license": "Proprietary",
  "isa": "RV32IM",
  "archived": false,
  "capabilities": {
    "browser": true,
    "assembler": true,
    "stepBack": true,
    "registers": true,
    "memory": true,
    "callStack": true,
    "ecalls": true,
    "gpio": true,
    "breakpoints": false,
    "pipeline": false,
    "caches": false,
    "rv64": false
  },
  "sources": [
    {
      "label": "Litessera Lux",
      "url": "https://lyszt.net/en/toolkit/litessera-lux"
    },
    {
      "label": "RISC-V lessons in Lux",
      "url": "https://lyszt.net/en/academia/resources/riscv/learn/intro"
    },
    {
      "label": "RV32IM instruction reference",
      "url": "https://lyszt.net/en/academia/resources/riscv"
    }
  ],
  "blocks": [
    {
      "k": "h",
      "text": "Overview"
    },
    {
      "k": "p",
      "text": "Litessera Lux is a RISC-V assembler and simulator built for this site's lessons. A simulator imitates a processor, which lets a program run without RISC-V hardware. Assembly is the readable text form of machine instructions, and RV32IM is the 32-bit base instruction set with the M extension for multiplication and division."
    },
    {
      "k": "p",
      "text": "The assembler is written in JavaScript and reads the source twice. The first pass records labels and the size of each instruction. The second pass encodes instructions and fills in the addresses those labels stand for. Execution happens in a C++ core compiled to WebAssembly, a binary format that browsers run at close to native speed."
    },
    {
      "k": "h",
      "text": "History"
    },
    {
      "k": "p",
      "text": "Lux began in 2026 as Tesserae Venus, a simulator written for this site's RISC-V lessons. It was renamed Litessera Lux in June 2026. The execution core later moved from JavaScript to C++ compiled to WebAssembly."
    },
    {
      "k": "h",
      "text": "Where it is used"
    },
    {
      "k": "p",
      "text": "The site's RISC-V lessons run on Lux. A lesson opens with a program for the student to assemble and run, and the instruction reference documents the same RV32IM instructions."
    },
    {
      "k": "p",
      "text": "Lux also handles embedded topics, including the ESP32 family of microcontrollers. It runs in the browser with nothing to install, so it works on managed school machines and on a student's own computer."
    }
  ]
}
